import axios from 'axios';
import { IPlantsPerHectare } from '../../../@types/model/masterData/plantsPerHectare/plantsPerHectare';
import { IPlantsPerHectareUpsert } from '../../../@types/model/masterData/plantsPerHectare/plantsPerHectareUpsert';
import { UpsertTypeEnum } from '../../../@types/enum/upsertType';

export default class PlantsPerHectareHttpService {
    public static getList = async (lastSyncedTimeUnix : number, signal ?: AbortSignal) : Promise<Array<IPlantsPerHectare>> => {
        const result = await axios.get(`${API_URL}/v1/MasterData/PlantsPerHectare/GetList`, {
            params: {
                lastSyncedTimeUnix
            },
            signal
        });

        return result.data;
    }

    public static upsert = async (upsert : IPlantsPerHectareUpsert, type : UpsertTypeEnum) : Promise<IPlantsPerHectare> => {
        const result = await axios.post(`${API_URL}/v1/MasterData/PlantsPerHectare/${type}`, upsert);

        return result.data;
    }

    public static delete = async (id : number) : Promise<void> => {
        return await axios.delete(`${API_URL}/v1/MasterData/PlantsPerHectare/Delete`, {
            params: { id },
        });
    }
}